module.exports = __webpack_public_path__ + "media/login_video.6ae76157.mp4";